export default __webpack_public_path__ + "static/media/ABChanelCorpo-SemiBold.5327caad.woff";